export default __webpack_public_path__ + "static/media/Amp.96eba9b9.png";